// extracted by mini-css-extract-plugin
module.exports = {"author":"zine-author_author__DP6j3","name":"zine-author_name__TOKjX","link":"zine-author_link__fwR0j"};